export const meta = {
    data() {
        return {
            item: null
        }
    },
    computed: {
        title() {
            return `${this.item.name} - 오늘은 경리단`
        },
        ogTitle() {
            return { name: 'og:title', content: this.title }
        },
        ogUrl() {
            return { name: 'og:url', content: window.location.href }
        }
    },
}